module.exports = __webpack_public_path__ + "static/media/IndoorSand2CourtPano.0b21edc1.jpg";